import React from 'react';
import { FilterDropdownProps } from 'antd/es/table/interface';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import TableFilterSelect from '../../../../../components/_table/TableFilterSelect';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import { setNumberWithComma } from '../../../../../lib/common';
import makeSelectOptionList from '../../../../../lib/utils/list/makeSelectOptionList';
import { PRODUCT_STATUS_STR, PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';

/**
 *  선택된 기획전 아이템 리스트와 기획전 리스트의 공통 컬럼
 */
export const columns = (data: any) => {
  const { filterOption, onFilter, isModal } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'imageUrl',
      render: (value: string) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
      width: '80px',
    },
    {
      title: <TableColumnTitle title={'브랜드명'} filterValue={filterOption.brandName} />,
      dataIndex: 'brandName',
      filterDropdown: ({ confirm }: FilterDropdownProps) => (
        <TableFilterInput
          placeholder="브랜드명 검색"
          option={filterOption.brandName}
          confirm={confirm}
          onFilter={(brandName: string) => onFilter({ brandName })}
        />
      ),
      width: '150px',
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} filterValue={filterOption.brandId} />,
      dataIndex: 'brandId',
      filterDropdown: ({ confirm }: FilterDropdownProps) => (
        <TableFilterInput
          type="number"
          placeholder="브랜드 ID 검색"
          option={filterOption.brandId}
          confirm={confirm}
          onFilter={(brandId: number) => onFilter({ brandId })}
        />
      ),
      render: (value: number) => <OpenBrandDetail text={value} storeId={value} />,
      width: '100px',
    },
    {
      title: <TableColumnTitle title={'상품 ID'} filterValue={filterOption.id} />,
      dataIndex: 'id',
      filterDropdown: ({ confirm }: FilterDropdownProps) => (
        <TableFilterInput
          type="number"
          placeholder="상품 ID 검색"
          option={filterOption.id}
          confirm={confirm}
          onFilter={(id: number) => onFilter({ id })}
        />
      ),
      render: (value: number) => <OpenProductDetail text={value} productId={value} />,
      width: '100px',
    },
    {
      title: <TableColumnTitle title={'상품명'} filterValue={filterOption.name} />,
      dataIndex: 'name',
      filterDropdown: ({ confirm }: FilterDropdownProps) => (
        <TableFilterInput
          placeholder="상품명 검색"
          option={filterOption.name}
          confirm={confirm}
          onFilter={(name: string) => onFilter({ name })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상태'} filterValue={PRODUCT_STATUS_TEXT[filterOption.status]} />,
      dataIndex: 'status',
      filterDropdown: isModal
        ? null
        : ({ confirm }: FilterDropdownProps) => (
            <TableFilterSelect
              list={makeSelectOptionList(Object.values(PRODUCT_STATUS_STR), PRODUCT_STATUS_TEXT)}
              option={filterOption.status}
              confirm={confirm}
              onFilter={(status: string) => onFilter({ status })}
            />
          ),
      render: (value: string) => PRODUCT_STATUS_TEXT[value],
      width: '120px',
    },
    {
      title: <TableColumnTitle title={'1차 카테고리'} />,
      dataIndex: 'category',
      render: (value: string) => (
        <div className="ellipsis" style={{ width: '150px' }}>
          {value}
        </div>
      ),
      width: '170px',
    },
    {
      title: <TableColumnTitle title={'판매가 (원)'} />,
      dataIndex: 'originPrice',
      render: (value: number) => setNumberWithComma(value),
      width: '100px',
    },
    {
      title: <TableColumnTitle title={'할인가 (원)'} />,
      dataIndex: 'discountPrice',
      render: (value: number) => setNumberWithComma(value),
      width: '100px',
    },
    {
      title: <TableColumnTitle title={'할인율 (%)'} />,
      dataIndex: 'discountRate',
      render: (value: number) => setNumberWithComma(value),
      width: '80px',
    },
    {
      title: <TableColumnTitle title={'할인기간'} />,
      dataIndex: 'discountPeriod',
      render: (value: string) => <div style={{ whiteSpace: 'pre' }}>{value}</div>,
      width: '170px',
    },
    {
      title: <TableColumnTitle title={'실판매가 (원)'} />,
      dataIndex: 'salesPrice',
      render: (value: number) => setNumberWithComma(value),
      width: '100px',
    },
    {
      title: <TableColumnTitle title={'등록일'} />,
      dataIndex: 'createDate',
      width: '170px',
    },
  ];
};
